import Formation from './Formation';

export const formationRoutes = [{path: '/formations/:id', name: 'Formation', Component: Formation}];
